/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations>): BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations(), model);
        BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations>): BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations.newInstance(<BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicUpdateUnitPriceForViolations.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
